module.exports = __webpack_public_path__ + "img/plus_btn.236f8272.png";